// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"76f3caf9","308":"52a27bcc","453":"3cb626a4"}[chunkId] + ".chunk.js";
};